module.exports = __webpack_public_path__ + "static/img/18027A_2_3_R_20190705_LC.d515ca4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/18027A_2_3_R_20190705_LC.png
// module id = hU+O
// module chunks = 0